import request from '@/config/axios'

/** O2O 机构 — 阶段 3 对接 /admin-api/o2o/institution/* */
export const O2oInstitutionApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/institution/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/o2o/institution/get?id=' + id })
  },
  create: async (data: {
    name: string
    licenseNo: string
    licenseUrl?: string
    legalPerson: string
    idCardFront?: string
    idCardBack?: string
    contactPhone: string
    contactEmail?: string
    province?: string
    city?: string
    district?: string
    address?: string
    loginUsername?: string
    loginPassword: string
  }) => {
    return await request.post<{
      institutionId: number
      merchantAccountId: number
      shopId: number
      loginUsername: string
    }>({ url: '/o2o/institution/create', data })
  },
  updateStatus: async (data: { id: number; status: string }) => {
    return await request.put({ url: '/o2o/institution/update-status', data })
  },
  creditDeposit: async (data: {
    institutionId: number
    amount: number
    bizNo?: string
    remark?: string
  }) => {
    return await request.post({ url: '/o2o/institution/deposit/credit', data })
  },
  deductDeposit: async (data: { institutionId: number; amount: number; remark?: string }) => {
    return await request.post({ url: '/o2o/institution/deposit/deduct', data })
  },
  getDepositRecordPage: async (params: {
    institutionId: number
    pageNo: number
    pageSize: number
  }) => {
    return await request.get({ url: '/o2o/institution/deposit/record/page', params })
  }
}

export const O2oInstitutionApplyApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/institution/apply/page', params })
  },
  get: async (id: number) => {
    return await request.get({ url: '/o2o/institution/apply/get?id=' + id })
  },
  approve: async (data: any) => {
    return await request.put({ url: '/o2o/institution/apply/approve', data })
  },
  reject: async (data: any) => {
    return await request.put({ url: '/o2o/institution/apply/reject', data })
  }
}

/** 机构扩品类审核 */
export const O2oInstitutionCategoryApplyApi = {
  getPage: async (params: any) => {
    return await request.get({ url: '/o2o/institution/category-apply/page', params })
  },
  approve: async (data: { id: number; auditRemark?: string }) => {
    return await request.put({ url: '/o2o/institution/category-apply/approve', data })
  },
  reject: async (data: { id: number; auditRemark?: string }) => {
    return await request.put({ url: '/o2o/institution/category-apply/reject', data })
  }
}
